module.exports = __webpack_public_path__ + "assets/a215d715268a4e76951a01bf9ab3348b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/latch.mp3
 ** module id = 331
 ** module chunks = 0
 **/